import { createSelector } from 'reselect';
import CarrierMailRegistrationDeviceDeliveryDetailsColumns from '../../containers/CarrierMailRegistrationDeviceDeliveryDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.isLoading;

export const getData =
  ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierMailRegistrationDeviceDeliveryDetailsColumns);
